/**
 * BX workshop grids — Cowlendar extapi (services list + event calendar + availability).
 * See sections bx-workshop-cowlendar-services-grid and bx-workshop-cowlendar-events-grid.
 */
(function () {
  'use strict';

  if (window.__bxWsCowlendarGridsBooted) return;
  window.__bxWsCowlendarGridsBooted = true;

  /**
   * Één gedeelde promise per exacte URL — voorkomt dubbele services/events/avs/availability-calls
   * wanneer meerdere secties dezelfde Cowlendar-endpoints gebruiken.
   */
  var jsonFetchPromises = Object.create(null);

  function fetchJsonCached(url) {
    if (!url || typeof url !== 'string') return Promise.reject(new Error('bx-cwl: missing url'));
    var key = url.trim();
    if (jsonFetchPromises[key] != null) return jsonFetchPromises[key];
    jsonFetchPromises[key] = fetch(key, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .catch(function (e) {
        delete jsonFetchPromises[key];
        throw e;
      });
    return jsonFetchPromises[key];
  }

  function hideLoading(root) {
    var loadEl = root.querySelector('[data-bx-ws-loading]');
    if (loadEl) loadEl.hidden = true;
  }

  /** @param {ParentNode} root — sectie-root (data-bx-ws-cowlendar-*) */
  function importTemplate(root, selector) {
    var t = typeof selector === 'string' ? root.querySelector(selector) : selector;
    if (!t || t.tagName !== 'TEMPLATE') return null;
    return document.importNode(t.content, true);
  }

  /**
   * Vult bestaande knoppen in [data-cwl-actions] (uit Liquid <template>).
   */
  function wireBookableActions(actionsEl, cfg, opts) {
    if (!actionsEl) return;
    var det = actionsEl.querySelector('[data-cwl-btn-details]');
    var link = actionsEl.querySelector('[data-cwl-btn-book-link]');
    var modal = actionsEl.querySelector('[data-cwl-btn-book-modal]');
    var dis = actionsEl.querySelector('[data-cwl-btn-book-disabled]');
    var available = opts.available;
    var cowVal = opts.cowVal;
    var bookHref = opts.bookHref || '#';
    var detailsHref = opts.detailsHref || '#';
    var bookLabel = opts.bookLabel != null && opts.bookLabel !== '' ? opts.bookLabel : cfg.bookLabel;

    if (det) {
      det.setAttribute('href', detailsHref);
      if (cfg.detailsLabel) {
        var detLabel = det.querySelector('[data-cwl-details-label]');
        if (detLabel) detLabel.textContent = cfg.detailsLabel;
        else det.textContent = cfg.detailsLabel;
      }
    }
    if (link) link.textContent = bookLabel;
    if (modal) modal.textContent = bookLabel;

    if (!available) {
      setListSlotVisible(link, false);
      if (modal) modal.removeAttribute('data-cowlendar-btn');
      setListSlotVisible(modal, false);
      if (dis) {
        dis.textContent = cfg.bookLabelDisabled || 'Niet beschikbaar';
        setListSlotVisible(dis, true);
      }
      return;
    }
    setListSlotVisible(dis, false);

    if (cfg.bookOpensModal && cowVal) {
      setListSlotVisible(link, false);
      if (modal) modal.setAttribute('data-cowlendar-btn', cowVal);
      setListSlotVisible(modal, true);
    } else {
      if (modal) modal.removeAttribute('data-cowlendar-btn');
      setListSlotVisible(modal, false);
      if (link) link.setAttribute('href', bookHref);
      setListSlotVisible(link, true);
    }
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function todayIsoLocal() {
    var n = new Date();
    return n.getFullYear() + '-' + pad2(n.getMonth() + 1) + '-' + pad2(n.getDate());
  }

  function formatDurationNl(totalMin) {
    if (totalMin == null || isNaN(totalMin)) return '';
    var h = Math.floor(Number(totalMin) / 60);
    var m = Number(totalMin) % 60;
    if (m === 0) return h + ' uur';
    return h + ' uur, ' + m + ' minuten';
  }

  function formatMoneyEur(amount) {
    if (amount == null || isNaN(amount)) return '';
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Number(amount));
    } catch (e) {
      return '€' + Number(amount).toFixed(2).replace('.', ',');
    }
  }

  function splitTitlePitmaster(raw) {
    if (!raw || typeof raw !== 'string') return { title: '', pitmaster: '' };
    var m = raw.match(/\s*-\s*Pitmaster\s*:\s*(.+)$/i);
    if (m) return { title: raw.slice(0, m.index).trim(), pitmaster: m[1].trim() };
    return { title: raw.trim(), pitmaster: '' };
  }

  function pillLabel(iso) {
    var d = new Date(iso + 'T12:00:00');
    return d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function buildAvailabilityUrl(calendarId, variantId, duration, timezone, quantity, year, month) {
    var u = new URL('https://app.cowlendar.com/extapi/calendar/' + encodeURIComponent(calendarId) + '/availability');
    u.searchParams.set('year', String(year));
    u.searchParams.set('month', String(month));
    u.searchParams.set('timezone', timezone || 'Europe/Amsterdam');
    u.searchParams.append('quantity_details[0][type]', 'default');
    u.searchParams.append('quantity_details[0][quantity]', String(quantity || 1));
    u.searchParams.append('quantity_details[0][name]', 'Default');
    u.searchParams.set('teammate_id', 'all');
    u.searchParams.set('duration', String(duration || 270));
    u.searchParams.set('is_manual', 'false');
    u.searchParams.set('variant_id', String(variantId));
    return u.toString();
  }

  function buildEventsApiUrl(calendarId, period, timezone) {
    var u = new URL('https://app.cowlendar.com/extapi/event-calendar/events');
    u.searchParams.set('calendar_id', calendarId);
    u.searchParams.set('period', period);
    u.searchParams.set('current_view', 'grid');
    u.searchParams.set('timezone', timezone || 'Europe/Amsterdam');
    u.searchParams.set('is_preview', 'false');
    return u.toString();
  }

  function shopParamFromServicesUrl(servicesUrl) {
    try {
      var u = new URL(servicesUrl);
      return u.searchParams.get('shop') || '';
    } catch (e) {
      return '';
    }
  }

  /** Cowlendar AVS per service-id uit dezelfde services-list response. */
  function buildAvsUrlForService(servicesUrl, serviceId) {
    var shop = shopParamFromServicesUrl(servicesUrl);
    if (!shop || !serviceId) return '';
    return (
      'https://app.cowlendar.com/extapi/sections/services_list/avs/' +
      encodeURIComponent(String(serviceId)) +
      '?shop=' +
      encodeURIComponent(shop)
    );
  }

  function upcomingYearMonths(monthsAhead) {
    var out = [];
    var d = new Date();
    var n = Math.max(1, Math.min(12, monthsAhead || 4));
    for (var i = 0; i < n; i++) {
      out.push({ year: d.getFullYear(), month: d.getMonth() + 1 });
      d.setMonth(d.getMonth() + 1);
    }
    return out;
  }

  /**
   * @returns {Promise<string[]>} YYYY-MM-DD sorted
   */
  async function fetchBookableDatesForService(calendarId, variantId, duration, timezone, monthsAhead, quantity) {
    var set = {};
    var months = upcomingYearMonths(monthsAhead);
    for (var i = 0; i < months.length; i++) {
      var y = months[i].year;
      var m = months[i].month;
      try {
        var data = await fetchJsonCached(buildAvailabilityUrl(calendarId, variantId, duration, timezone, quantity, y, m));
        if (Array.isArray(data.short)) {
          data.short.forEach(function (iso) {
            if (iso && typeof iso === 'string') set[iso] = true;
          });
        }
        if (Array.isArray(data.long)) {
          data.long.forEach(function (row) {
            if (row && row.is_bookable !== false && row.slot) {
              var day = String(row.slot).slice(0, 10);
              if (/^\d{4}-\d{2}-\d{2}$/.test(day)) set[day] = true;
            }
          });
        }
      } catch (e) { /* ignore */ }
    }
    var todayLocal = todayIsoLocal();
    return Object.keys(set)
      .filter(function (iso) {
        return iso >= todayLocal;
      })
      .sort();
  }

  /** Normaliseert event/availability slot-strings naar vergelijkbare sleutel (YYYY-MM-DD HH:mm). */
  function normSlotKey(s) {
    if (!s || typeof s !== 'string') return '';
    var t = s.trim().replace('T', ' ');
    t = t.replace(/\.\d+Z?$/, '').replace(/Z$/, '');
    var m = t.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}):(\d{2})/);
    if (m) return m[1] + ' ' + m[2] + ':' + m[3];
    if (t.length >= 10 && /^\d{4}-\d{2}-\d{2}$/.test(t.slice(0, 10))) return t.slice(0, 10);
    return '';
  }

  function availabilityRowQuantities(row) {
    if (!row || typeof row !== 'object') return { remaining: null, capacity: null };
    var left = numOrNull(row.qty_left);
    var max = numOrNull(row.max_qty);
    if ((left === null || max === null) && row.slot_details && typeof row.slot_details === 'object' && !Array.isArray(row.slot_details)) {
      var def = row.slot_details.default;
      if (!def && typeof row.slot_details === 'object') {
        var ks = Object.keys(row.slot_details);
        if (ks.length) def = row.slot_details[ks[0]];
      }
      if (def && typeof def === 'object') {
        if (left === null) left = numOrNull(def.left);
        if (max === null) max = numOrNull(def.max);
      }
    }
    return { remaining: left, capacity: max };
  }

  function applySlotRowsToMap(map, rows) {
    if (!map || !Array.isArray(rows)) return;
    rows.forEach(function (row) {
      if (!row) return;
      var key = normSlotKey(row.slot_start || row.slot || '');
      if (!key) return;
      var q = availabilityRowQuantities(row);
      if (q.remaining !== null || q.capacity !== null) {
        map[key] = q;
      }
    });
  }

  /**
   * GET …/sections/services_list/avs/{id} — bevat slots[] met o.a. qty_left, max_qty (zelfde vorm als availability long[]).
   * @see https://app.cowlendar.com/extapi/sections/services_list/avs/…
   */
  async function fetchAvsSlotsMap(url) {
    var map = {};
    if (!url || typeof url !== 'string') return map;
    try {
      var data = await fetchJsonCached(url.trim());
      applySlotRowsToMap(map, data.slots || []);
      if (Object.keys(map).length === 0 && Array.isArray(data.long)) {
        applySlotRowsToMap(map, data.long);
      }
    } catch (e) {
      /* ignore */
    }
    return map;
  }

  function avsMapsBundleHasSlots(avsByService) {
    if (!avsByService || typeof avsByService !== 'object') return false;
    var ids = Object.keys(avsByService);
    for (var i = 0; i < ids.length; i++) {
      var m = avsByService[ids[i]];
      if (m && typeof m === 'object' && Object.keys(m).length > 0) return true;
    }
    return false;
  }

  /**
   * Voor elke service._id uit de services-list: GET …/services_list/avs/{_id}?shop=…
   * (gedeeld met prefetch via fetchJsonCached).
   */
  async function fetchAvsSlotMapsByServicesList(servicesUrl) {
    var byId = {};
    if (!servicesUrl) return byId;
    try {
      var body = await fetchJsonCached(servicesUrl);
      var list = (body && (body.services || body.data)) || [];
      if (!Array.isArray(list) || list.length === 0) return byId;
      var tasks = [];
      list.forEach(function (svc) {
        if (!svc || !svc._id) return;
        var avsU = buildAvsUrlForService(servicesUrl, svc._id);
        if (!avsU) return;
        tasks.push(
          fetchAvsSlotsMap(avsU).then(function (map) {
            byId[svc._id] = map;
          }),
        );
      });
      await Promise.all(tasks);
    } catch (e) {
      /* partial byId */
    }
    return byId;
  }

  function slotKeyToMinutes(key) {
    if (!key) return null;
    var m = String(key).match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}):(\d{2})/);
    if (!m) return null;
    return parseInt(m[2], 10) * 60 + parseInt(m[3], 10);
  }

  /** Duur in minuten: event eind−start, anders service.duration, anders theme-default. */
  function eventDurationMinutes(ev, serviceInfo, cfg) {
    var start = ev && ev.start_date;
    var end = ev && ev.end_date;
    if (start && end) {
      var t0 = new Date(String(start).replace(' ', 'T'));
      var t1 = new Date(String(end).replace(' ', 'T'));
      var ms = t1.getTime() - t0.getTime();
      if (!isNaN(ms) && ms > 60000) return Math.round(ms / 60000);
    }
    if (serviceInfo && serviceInfo.duration != null) {
      var sd = Number(serviceInfo.duration);
      if (!isNaN(sd) && sd > 0) return sd;
    }
    var def = cfg && cfg.defaultAvailabilityDuration != null ? Number(cfg.defaultAvailabilityDuration) : 270;
    return !isNaN(def) && def > 0 ? def : 270;
  }

  function lookupSlotQuantitiesInMap(map, startDateStr) {
    if (!map || typeof map !== 'object' || !startDateStr) return null;
    var full = normSlotKey(startDateStr);
    if (full && map[full]) return map[full];
    if (!full || full.length < 10) return null;
    var day = full.slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
    var matches = Object.keys(map).filter(function (k) {
      return k.slice(0, 10) === day;
    });
    if (matches.length === 0) return null;
    if (matches.length === 1) return map[matches[0]];
    var eventMins = slotKeyToMinutes(full);
    if (eventMins === null) return null;
    var bestKey = null;
    var bestDist = Infinity;
    matches.forEach(function (k) {
      var km = slotKeyToMinutes(k);
      if (km === null) return;
      var dist = Math.abs(km - eventMins);
      if (dist < bestDist) {
        bestDist = dist;
        bestKey = k;
      }
    });
    return bestKey ? map[bestKey] : null;
  }

  function mergeSlotMaps(target, source) {
    if (!target || !source) return target;
    Object.keys(source).forEach(function (k) {
      target[k] = source[k];
    });
    return target;
  }

  /**
   * Kaart genormaliseerde slot → { remaining, capacity } uit /calendar/{serviceId}/availability → long[].
   */
  async function fetchAvailabilityLongSlotMap(serviceCalendarId, variantId, duration, timezone, quantity, monthsAhead) {
    var map = {};
    if (!serviceCalendarId || !variantId) return map;
    var months = upcomingYearMonths(monthsAhead);
    for (var i = 0; i < months.length; i++) {
      var y = months[i].year;
      var mo = months[i].month;
      try {
        var data = await fetchJsonCached(buildAvailabilityUrl(serviceCalendarId, variantId, duration, timezone, quantity, y, mo));
        if (!Array.isArray(data.long)) continue;
        applySlotRowsToMap(map, data.long);
      } catch (e) { /* skip month */ }
    }
    return map;
  }

  function lookupAvailabilitySpots(slotMapsByService, serviceId, startDateStr) {
    if (!slotMapsByService || !serviceId || !startDateStr) return null;
    return lookupSlotQuantitiesInMap(slotMapsByService[serviceId], startDateStr);
  }

  async function buildAvailabilitySlotMapsForEvents(events, serviceMap, cfg) {
    var out = {};
    var durationsByService = Object.create(null);
    var rawAhead = cfg.availabilityMonthsAhead != null ? Number(cfg.availabilityMonthsAhead) : 0;
    var monthsAhead =
      rawAhead > 0 ? rawAhead : Number(cfg.monthsToFetch) || 6;
    if (monthsAhead < 1) monthsAhead = 1;
    if (monthsAhead > 12) monthsAhead = 12;
    var qty = cfg.availabilityQuantity != null ? Number(cfg.availabilityQuantity) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;
    var tz = cfg.timezone || 'Europe/Amsterdam';

    events.forEach(function (ev) {
      var sid = ev && ev.service_id;
      if (!sid) return;
      var dur = eventDurationMinutes(ev, serviceMap[sid], cfg);
      if (!durationsByService[sid]) durationsByService[sid] = Object.create(null);
      durationsByService[sid][dur] = true;
    });

    var tasks = [];
    Object.keys(durationsByService).forEach(function (sid) {
      var inf = serviceMap[sid] || {};
      var vid = inf.variantId;
      if (!vid) {
        out[sid] = {};
        return;
      }
      var durs = Object.keys(durationsByService[sid]).map(Number);
      tasks.push(
        (function (serviceId, durations) {
          return Promise.all(
            durations.map(function (dur) {
              return fetchAvailabilityLongSlotMap(serviceId, vid, dur, tz, qty, monthsAhead);
            }),
          ).then(function (maps) {
            var merged = {};
            maps.forEach(function (m) {
              mergeSlotMaps(merged, m);
            });
            out[serviceId] = merged;
          });
        })(sid, durs),
      );
    });
    await Promise.all(tasks);
    return out;
  }

  function overlaySpots(base, extra) {
    if (!extra || (extra.remaining == null && extra.capacity == null)) return base;
    return {
      remaining: extra.remaining != null ? extra.remaining : base.remaining,
      capacity: extra.capacity != null ? extra.capacity : base.capacity,
    };
  }

  /** availability (juiste duur, exact slot) → AVS → event-payload. */
  function resolveEventListSpots(ev, serviceInfo, avsByService, slotMaps, cfg) {
    var spots = eventSpotsInfo(ev);
    var sid = ev && ev.service_id;
    var start = ev && ev.start_date;
    if (!sid || !start) return spots;
    var exactKey = normSlotKey(start);
    var calMap = slotMaps && slotMaps[sid];
    var avMap = avsByService && avsByService[sid];
    if (calMap && exactKey && calMap[exactKey]) return overlaySpots(spots, calMap[exactKey]);
    if (calMap) {
      var calSpots = lookupSlotQuantitiesInMap(calMap, start);
      if (calSpots) return overlaySpots(spots, calSpots);
    }
    if (avMap && exactKey && avMap[exactKey]) return overlaySpots(spots, avMap[exactKey]);
    if (avMap) {
      var avSpots = lookupSlotQuantitiesInMap(avMap, start);
      if (avSpots) return overlaySpots(spots, avSpots);
    }
    return spots;
  }

  function el(tag, className, attrs) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (attrs[k] != null) n.setAttribute(k, attrs[k]);
      });
    }
    return n;
  }

  function renderDatePills(root, host, dates, calendarId, variantId, maxPills) {
    if (!host) return;
    host.innerHTML = '';
    var tpl = root.querySelector('template[data-cwl-date-pill]');
    var cap = maxPills != null ? maxPills : 3;
    var slice = dates.slice(0, cap);
    var btnVal = calendarId + '-' + variantId;
    slice.forEach(function (iso) {
      var frag = tpl ? importTemplate(root, 'template[data-cwl-date-pill]') : null;
      var btn = frag ? frag.querySelector('[data-cwl-pill-btn]') : null;
      var li;
      if (btn) {
        btn.setAttribute('data-cowlendar-btn', btnVal);
        btn.setAttribute('data-bx-cowlendar-date', iso);
        btn.textContent = 'Volgende: ' + pillLabel(iso);
        li = frag.querySelector('li') || frag.firstElementChild;
      } else {
        li = el('li', 'bx:m-0 bx:list-none bx:inline-flex bx:p-0');
        btn = el(
          'div',
          'bx:inline-flex bx:cursor-pointer bx:rounded-md bx:border bx:border-green-100 bx:bg-green-50 bx:px-2.5 bx:py-1 bx:text-xs bx:font-semibold bx:text-[#16a34a]',
          {
            'data-cowlendar-btn': btnVal,
            'data-bx-cowlendar-date': iso,
            role: 'button',
            tabindex: '0',
          },
        );
        btn.textContent = 'Volgende: ' + pillLabel(iso);
        li.appendChild(btn);
      }
      if (li) host.appendChild(li);
    });
  }

  async function loadServices(root, cfg) {
    var mount = root.querySelector('[data-bx-ws-mount]');
    var errEl = root.querySelector('[data-bx-ws-error]');
    if (!mount) return;

    mount.innerHTML = '';
    errEl.hidden = true;

    try {
      var body = await fetchJsonCached(cfg.servicesUrl);
      var list = body.services || body.data || [];
      if (!Array.isArray(list)) throw new Error('Ongeldig antwoord');

      if (list.length === 0) {
        var emp = el('p', 'bx:text-gray-600');
        emp.textContent = 'Geen workshops in deze lijst.';
        mount.appendChild(emp);
        if (cfg.showCount && root.querySelector('[data-bx-ws-count]')) {
          root.querySelector('[data-bx-ws-count]').textContent = '0';
        }
        hideLoading(root);
        return;
      }

      if (cfg.showCount && root.querySelector('[data-bx-ws-count]')) {
        root.querySelector('[data-bx-ws-count]').textContent = String(list.length);
      }

      var ul = el('ul', 'bx:grid bx:list-none bx:grid-cols-1 bx:gap-6 bx:p-0 bx:m-0 bx:sm:grid-cols-2 bx:md:gap-8 ' + (cfg.columns === '4' ? 'bx:lg:grid-cols-4' : 'bx:lg:grid-cols-3'));
      ul.setAttribute('role', 'list');
      var cardTpl = root.querySelector('template[data-cwl-service-card]');

      var i = 0;
      for (var si = 0; si < list.length; si++) {
        var svc = list[si];
        var v0 = svc.variants && svc.variants[0];
        if (!v0) continue;

        var parsed = splitTitlePitmaster(svc.title || '');
        var displayTitle = parsed.title || svc.title || '';
        var pitmaster = parsed.pitmaster;
        var priceStr = formatMoneyEur(v0.price);
        var fromPrefix = svc.show_from_price_text ? (cfg.priceFromLabel + ' ') : '';
        var durStr = cfg.showDuration ? formatDurationNl(svc.duration) : '';
        var detailsHref = svc.product_page_url || '#';
        var calendarId = svc._id;
        var variantId = v0.id;

        var frag = cardTpl ? importTemplate(root, cardTpl) : null;
        var li;
        if (frag) {
          li = frag.querySelector('li');
          var imgLink = frag.querySelector('[data-cwl-card-image-link]');
          var imgEl = frag.querySelector('[data-cwl-card-img]');
          var imgPh = frag.querySelector('[data-cwl-card-img-placeholder]');
          if (imgLink) imgLink.setAttribute('href', detailsHref);
          if (svc.thumbnail && imgEl) {
            imgEl.src = svc.thumbnail;
            imgEl.alt = displayTitle;
            imgEl.loading = i >= 3 ? 'lazy' : 'eager';
            imgEl.hidden = false;
            if (imgPh) imgPh.hidden = true;
          } else if (imgPh) {
            imgPh.textContent = displayTitle;
            imgPh.hidden = false;
            if (imgEl) imgEl.hidden = true;
          }
          var titleA = frag.querySelector('[data-cwl-title]');
          if (titleA) {
            titleA.textContent = displayTitle;
            titleA.setAttribute('href', detailsHref);
          }
          var pitRow = frag.querySelector('[data-cwl-pitmaster-row]');
          if (pitRow) {
            if (pitmaster && cfg.showPitmaster) {
              pitRow.hidden = false;
              var tl = frag.querySelector('[data-cwl-trainer-label]');
              var nm = frag.querySelector('[data-cwl-pitmaster-name]');
              if (tl) tl.textContent = cfg.trainerLabel + ' ';
              if (nm) nm.textContent = pitmaster;
            } else {
              pitRow.hidden = true;
            }
          }
          var durRow = frag.querySelector('[data-cwl-duration-row]');
          if (durRow) {
            if (durStr) {
              durRow.hidden = false;
              var dt = frag.querySelector('[data-cwl-duration-text]');
              if (dt) dt.textContent = durStr;
            } else {
              durRow.hidden = true;
            }
          }
          var priceEl = frag.querySelector('[data-cwl-price]');
          if (priceEl) priceEl.textContent = fromPrefix + priceStr;
          var pillsHost = frag.querySelector('[data-cwl-pills-host]');
          var act = frag.querySelector('[data-cwl-actions]');
          wireBookableActions(act, cfg, { available: true, detailsHref: detailsHref });
          if (cfg.showAvailabilityPills && pillsHost) {
            fetchBookableDatesForService(
              calendarId,
              variantId,
              svc.duration || cfg.defaultDuration,
              cfg.timezone,
              cfg.availabilityMonthsAhead,
              cfg.quantity
            ).then(function (dates) {
              renderDatePills(root, pillsHost, dates, calendarId, variantId, cfg.maxAvailabilityPills);
            });
          }
        } else {
          li = el('li', '');
          li.textContent = displayTitle;
        }
        if (li) ul.appendChild(li);
        i++;
      }

      mount.appendChild(ul);
      hideLoading(root);
    } catch (e) {
      hideLoading(root);
      errEl.textContent = cfg.errorMessage || 'Kon workshops niet laden. Probeer het later opnieuw.';
      errEl.hidden = false;
    }
  }

  function periodYm(d) {
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1);
  }

  function addMonths(d, n) {
    var x = new Date(d.getTime());
    x.setMonth(x.getMonth() + n);
    return x;
  }

  async function fetchEventsForRange(calendarId, timezone, monthsCount) {
    var all = [];
    var start = new Date();
    var n = Math.max(1, Math.min(12, monthsCount || 6));
    var tasks = [];
    for (var i = 0; i < n; i++) {
      var d = addMonths(start, i);
      var period = periodYm(d);
      var url = buildEventsApiUrl(calendarId, period, timezone);
      tasks.push(
        fetchJsonCached(url)
          .then(function (data) {
            return Array.isArray(data.events) ? data.events : [];
          })
          .catch(function () {
            return [];
          }),
      );
    }
    var chunks = await Promise.all(tasks);
    chunks.forEach(function (evs) {
      all = all.concat(evs);
    });
    return dedupeCalendarEvents(
      all.filter(function (ev) {
        return ev && (ev.id || (ev.service_id && ev.start_date));
      }),
    );
  }

  async function loadServiceTitleMap(servicesUrl) {
    if (!servicesUrl) return {};
    try {
      var body = await fetchJsonCached(servicesUrl);
      var list = body.services || [];
      var map = {};
      if (Array.isArray(list)) {
        list.forEach(function (s) {
          if (s && s._id) {
            var parsed = splitTitlePitmaster(s.title || '');
            map[s._id] = {
              title: parsed.title || s.title || '',
              product_page_url: s.product_page_url || '',
              variantId: s.variants && s.variants[0] && s.variants[0].id,
              duration: s.duration,
              thumbnail: s.thumbnail,
            };
          }
        });
      }
      return map;
    } catch (e) {
      return {};
    }
  }

  function formatEventWhen(startDateStr, endDateStr) {
    if (!startDateStr) return { dateLine: '', timeLine: '' };
    var start = new Date(startDateStr.replace(' ', 'T'));
    var end = endDateStr ? new Date(endDateStr.replace(' ', 'T')) : null;
    var dateLine = start.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    var t0 = start.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
    var t1 = end ? end.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }) : '';
    var timeLine = t1 ? t0 + ' – ' + t1 : t0;
    return { dateLine: dateLine, timeLine: timeLine };
  }

  function isEventBookable(ev) {
    if (!ev) return false;
    if (ev.is_not_bookable === true) return false;
    var st = String(ev.status || '')
      .toLowerCase()
      .trim();
    if (st === 'soldout' || st === 'sold_out' || st === 'full') return false;
    return st === 'available';
  }

  /** Cowlendar kan dezelfde sessie meerdere keren teruggeven (andere id, zelfde service + start). */
  function eventListDedupKey(ev) {
    if (!ev) return '';
    var sid = String(ev.service_id || '');
    var slot = normSlotKey(ev.start_date);
    if (sid && slot) return sid + '\0' + slot;
    if (ev.id) return 'id:' + String(ev.id);
    return '';
  }

  function preferEventForDedup(a, b) {
    if (!a) return b;
    if (!b) return a;
    var score = function (ev) {
      var s = 0;
      if (isEventBookable(ev)) s += 1000;
      if (ev.is_not_bookable !== true) s += 100;
      var st = String(ev.status || '')
        .toLowerCase()
        .trim();
      if (st === 'available') s += 50;
      var dur = Number(ev.duration);
      if (!isNaN(dur) && dur > 0) s += dur;
      return s;
    };
    return score(a) >= score(b) ? a : b;
  }

  function dedupeCalendarEvents(events) {
    var byKey = Object.create(null);
    var order = [];
    (events || []).forEach(function (ev) {
      if (!ev) return;
      var key = eventListDedupKey(ev);
      if (!key) return;
      if (!byKey[key]) {
        byKey[key] = ev;
        order.push(key);
      } else {
        byKey[key] = preferEventForDedup(byKey[key], ev);
      }
    });
    return order.map(function (k) {
      return byKey[k];
    });
  }

  function filterEventsWithKnownService(events, serviceMap) {
    if (!Array.isArray(events) || !serviceMap || typeof serviceMap !== 'object') return events;
    var known = Object.keys(serviceMap);
    if (known.length === 0) return events;
    return events.filter(function (ev) {
      return ev && ev.service_id && serviceMap[ev.service_id];
    });
  }

  function numOrNull(x) {
    if (x == null || x === '') return null;
    var v = Number(x);
    return isNaN(v) ? null : v;
  }

  function firstDefinedNum(obj, keys) {
    for (var i = 0; i < keys.length; i++) {
      var v = numOrNull(obj[keys[i]]);
      if (v !== null) return v;
    }
    return null;
  }

  function eventSpotSources(ev) {
    var list = [];
    if (!ev || typeof ev !== 'object') return list;
    list.push(ev);
    ['event', 'details', 'meta', 'slot', 'booking', 'calendar_event', 'calendarEvent', 'service_event'].forEach(function (k) {
      if (ev[k] != null && typeof ev[k] === 'object' && !Array.isArray(ev[k])) list.push(ev[k]);
    });
    return list;
  }

  /** Resterende plaatsen / capaciteit uit Cowlendar event-calendar payload (ook geneste objecten; veldnamen kunnen variëren). */
  function eventSpotsInfo(ev) {
    var sources = eventSpotSources(ev);
    var r = null;
    var cap = null;
    var booked = null;
    var rKeys = [
      'remaining_spots',
      'spots_remaining',
      'available_spots',
      'spots_left',
      'spaces_left',
      'free_spots',
      'remaining_capacity',
      'available_capacity',
      'open_spots',
      'quantity_available',
      'available_quantity',
      'seats_left',
      'tickets_left',
      'spotsAvailable',
      'remainingSeats',
      'qty_left',
      'left',
    ];
    var capKeys = [
      'max_capacity',
      'capacity',
      'attendee_limit',
      'max_attendees',
      'max_participants',
      'total_capacity',
      'group_size',
      'maxCapacity',
      'max_qty',
      'max',
    ];
    var bookedKeys = [
      'booked_count',
      'bookings_count',
      'current_bookings',
      'attendees_count',
      'participants_count',
      'filled_count',
      'reserved_count',
      'bookedCount',
    ];

    for (var i = 0; i < sources.length; i++) {
      var o = sources[i];
      if (r === null) r = firstDefinedNum(o, rKeys);
      if (cap === null) cap = firstDefinedNum(o, capKeys);
      if (booked === null) booked = firstDefinedNum(o, bookedKeys);
    }

    if (r === null && cap !== null && booked !== null) r = Math.max(0, cap - booked);
    return { remaining: r, capacity: cap };
  }

  function formatSpotsLine(info, cfg, opts) {
    opts = opts || {};
    var fb = cfg.spotsFallbackNote != null ? String(cfg.spotsFallbackNote).trim() : '';
    if (info.remaining == null) {
      if (opts.hideFallbackWhenUnknown) return '';
      return fb;
    }
    var rem = Number(info.remaining);
    if (isNaN(rem)) {
      if (opts.hideFallbackWhenUnknown) return '';
      return fb;
    }
    if (rem <= 0) return cfg.spotsFullLabel || 'Vol';
    if (rem === 1) return cfg.spotsOneLabel || 'Nog 1 plaats';
    var tmpl = String(cfg.spotsManyLabel || 'Nog COUNT plaatsen');
    return tmpl.replace(/\bCOUNT\b|__COUNT__|%NUM%|\{\{\s*n\s*\}\}/gi, String(rem));
  }

  function setListSlotVisible(el, visible) {
    if (!el) return;
    if (visible) {
      el.removeAttribute('hidden');
      el.classList.remove('bx:hidden');
    } else {
      el.setAttribute('hidden', '');
      el.classList.add('bx:hidden');
    }
  }

  async function loadAndFilterEvents(cfg) {
    var serviceMap = await loadServiceTitleMap(cfg.servicesUrl);
    var events = await fetchEventsForRange(cfg.calendarId, cfg.timezone, cfg.monthsToFetch || 6);
    events = filterEventsWithKnownService(events, serviceMap);
    events.sort(function (a, b) {
      return String(a.start_date).localeCompare(String(b.start_date));
    });
    if (cfg.hidePast) {
      var now = new Date();
      events = events.filter(function (ev) {
        if (!ev.start_date) return false;
        return new Date(ev.start_date.replace(' ', 'T')) >= now;
      });
    }
    return { serviceMap: serviceMap, events: events };
  }

  async function loadEventsList(root, cfg) {
    var mount = root.querySelector('[data-bx-ws-mount]');
    var errEl = root.querySelector('[data-bx-ws-error]');
    if (!mount) return;
    mount.innerHTML = '';
    errEl.hidden = true;

    try {
      var data = await loadAndFilterEvents(cfg);
      var serviceMap = data.serviceMap;
      var events = data.events;

      if (cfg.hideSoldOut !== false) {
        events = events.filter(isEventBookable);
      }

      if (cfg.showCount && root.querySelector('[data-bx-ws-count]')) {
        root.querySelector('[data-bx-ws-count]').textContent = String(events.length);
      }

      if (events.length === 0) {
        var emptyFrag = importTemplate(root, 'template[data-cwl-list-empty]');
        var emptyNode = emptyFrag ? emptyFrag.querySelector('[data-cwl-empty-text]') : null;
        if (emptyNode) {
          emptyNode.textContent = cfg.emptyMessage || 'Geen geplande data gevonden.';
          mount.appendChild(emptyFrag);
        } else {
          var emptyL = el('p', 'bx:text-gray-600');
          emptyL.textContent = cfg.emptyMessage || 'Geen geplande data gevonden.';
          mount.appendChild(emptyL);
        }
        hideLoading(root);
        return;
      }

      var wrapFrag = importTemplate(root, 'template[data-cwl-list-container]');
      var wrap = wrapFrag ? wrapFrag.querySelector('[data-cwl-list-root]') : null;
      if (!wrap) {
        wrap = el('div', 'bx:flex bx:flex-col bx:gap-4');
      }

      var cardTpl = root.querySelector('template[data-cwl-list-event-card]');
      if (!cardTpl) {
        var miss = el('p', 'bx:text-red-600');
        miss.textContent = 'Agenda-template ontbreekt (data-cwl-list-event-card).';
        mount.appendChild(miss);
        hideLoading(root);
        return;
      }

      var hadInvalidDate = false;

      var avsByService = await fetchAvsSlotMapsByServicesList(cfg.servicesUrl);
      var slotMaps = await buildAvailabilitySlotMapsForEvents(events, serviceMap, cfg);

      events.forEach(function (ev) {
        var info = serviceMap[ev.service_id] || {};
        var title = info.title || ('Workshop ' + (ev.service_id || '').slice(0, 8));
        var detailsHref = info.product_page_url || '#';
        var when = formatEventWhen(ev.start_date, ev.end_date);
        var available = isEventBookable(ev);
        var spots = resolveEventListSpots(ev, info, avsByService, slotMaps, cfg);

        var startOk = ev.start_date && typeof ev.start_date === 'string';
        var d = startOk ? new Date(ev.start_date.replace(' ', 'T')) : null;
        var dateValid = d != null && !isNaN(d.getTime());
        if (startOk && !dateValid) hadInvalidDate = true;

        var cFrag = importTemplate(root, cardTpl);
        var card = cFrag ? cFrag.querySelector('[data-cwl-event-card]') : null;
        if (!card) return;

        var badge = card.querySelector('[data-cwl-date-badge]');
        var ws = card.querySelector('[data-cwl-day-weekday-short]');
        var dn = card.querySelector('[data-cwl-day-number]');
        var dmonth = card.querySelector('[data-cwl-day-month]');
        if (dateValid) {
          if (badge) badge.hidden = false;
          if (ws) ws.textContent = d.toLocaleDateString('nl-NL', { weekday: 'short' });
          if (dn) dn.textContent = String(d.getDate());
          if (dmonth) dmonth.textContent = d.toLocaleDateString('nl-NL', { month: 'long' }).toLowerCase();
        } else {
          if (badge) badge.hidden = true;
          if (ws) ws.textContent = '';
          if (dn) dn.textContent = '';
          if (dmonth) dmonth.textContent = '';
        }

        var imgEl = card.querySelector('[data-cwl-avatar-img]');
        var imgFb = card.querySelector('[data-cwl-avatar-fallback]');
        if (info.thumbnail && imgEl && imgFb) {
          imgEl.removeAttribute('hidden');
          imgEl.setAttribute('src', info.thumbnail);
          imgEl.setAttribute('alt', title);
          imgFb.hidden = true;
        } else if (imgEl && imgFb) {
          imgEl.setAttribute('hidden', '');
          imgFb.hidden = false;
          imgFb.textContent = String((title || '?').trim().charAt(0) || '?').toUpperCase();
        }

        var titleA = card.querySelector('[data-cwl-title]');
        if (titleA) {
          titleA.textContent = title;
          titleA.setAttribute('href', detailsHref);
        }

        var dateLong = card.querySelector('[data-cwl-date-long]');
        if (dateLong) dateLong.textContent = dateValid ? when.dateLine : 'Datum onbekend';

        var tt = card.querySelector('[data-cwl-time]');
        if (tt) tt.textContent = when.timeLine || '';

        var priceWrap = card.querySelector('[data-cwl-price-wrap]');
        var priceEl = card.querySelector('[data-cwl-price]');
        if (ev.price && priceWrap && priceEl) {
          priceWrap.hidden = false;
          priceEl.textContent = typeof ev.price === 'string' ? ev.price : formatMoneyEur(ev.price);
        } else if (priceWrap) {
          priceWrap.hidden = true;
        }

        var viewLabel = cfg.viewLabel != null && cfg.viewLabel !== '' ? cfg.viewLabel : 'Bekijk';
        var spotsLine = formatSpotsLine(spots, cfg, { hideFallbackWhenUnknown: true });
        var prim = card.querySelector('[data-cwl-list-primary]');
        var primDis = card.querySelector('[data-cwl-list-primary-disabled]');
        var spotsText = card.querySelector('[data-cwl-spots-text]');
        if (available) {
          setListSlotVisible(primDis, false);
          if (prim) {
            setListSlotVisible(prim, true);
            prim.textContent = viewLabel;
            prim.setAttribute('href', detailsHref);
          }
        } else {
          setListSlotVisible(prim, false);
          if (primDis) {
            primDis.textContent = cfg.bookLabelDisabled || 'Niet beschikbaar';
            setListSlotVisible(primDis, true);
          }
        }

        if (spotsText) {
          if (spotsLine) {
            spotsText.textContent = spotsLine;
            setListSlotVisible(spotsText, true);
          } else {
            spotsText.textContent = '';
            setListSlotVisible(spotsText, false);
          }
        }

        wrap.appendChild(card);
      });

      if (hadInvalidDate) {
        var uFrag = importTemplate(root, 'template[data-cwl-list-unknown]');
        var uEl = uFrag ? uFrag.querySelector('[data-cwl-unknown-text]') : null;
        if (uEl) {
          uEl.textContent = 'Sommige items hebben geen geldige datum; controleer de gegevens in Cowlendar.';
          wrap.appendChild(uFrag);
        }
      }

      mount.appendChild(wrap);
      hideLoading(root);
    } catch (e) {
      hideLoading(root);
      errEl.textContent = cfg.errorMessage || 'Kon de agenda niet laden.';
      errEl.hidden = false;
    }
  }

  async function loadEvents(root, cfg) {
    var mount = root.querySelector('[data-bx-ws-mount]');
    var errEl = root.querySelector('[data-bx-ws-error]');
    if (!mount) return;
    mount.innerHTML = '';
    errEl.hidden = true;

    try {
      var data = await loadAndFilterEvents(cfg);
      var serviceMap = data.serviceMap;
      var events = data.events;

      if (cfg.showCount && root.querySelector('[data-bx-ws-count]')) {
        root.querySelector('[data-bx-ws-count]').textContent = String(events.length);
      }

      if (events.length === 0) {
        var gEmptyFrag = importTemplate(root, 'template[data-cwl-grid-empty]');
        var gEmptyNode = gEmptyFrag ? gEmptyFrag.querySelector('[data-cwl-empty-text]') : null;
        if (gEmptyNode) {
          gEmptyNode.textContent = cfg.emptyMessage || 'Geen geplande data gevonden.';
          mount.appendChild(gEmptyFrag);
        } else {
          var empty = el('p', 'bx:text-gray-600');
          empty.textContent = cfg.emptyMessage || 'Geen geplande data gevonden.';
          mount.appendChild(empty);
        }
        hideLoading(root);
        return;
      }

      var cardTpl = root.querySelector('template[data-cwl-event-grid-card]');
      if (!cardTpl) {
        var miss = el('p', 'bx:text-red-600');
        miss.textContent = 'Eventgrid-template ontbreekt (data-cwl-event-grid-card).';
        mount.appendChild(miss);
        hideLoading(root);
        return;
      }

      var ul = el('ul', 'bx:grid bx:list-none bx:grid-cols-1 bx:gap-6 bx:p-0 bx:m-0 bx:sm:grid-cols-2 bx:md:gap-8 ' + (cfg.columns === '4' ? 'bx:lg:grid-cols-4' : 'bx:lg:grid-cols-3'));
      ul.setAttribute('role', 'list');

      events.forEach(function (ev, idx) {
        var info = serviceMap[ev.service_id] || {};
        var title = info.title || ('Workshop ' + (ev.service_id || '').slice(0, 8));
        var detailsHref = info.product_page_url || '#';
        var bookHref = detailsHref.split('?')[0] + (cfg.bookAnchor || '');
        var variantId = info.variantId;
        var cowVal = variantId ? ev.service_id + '-' + variantId : '';
        var when = formatEventWhen(ev.start_date, ev.end_date);
        var available = isEventBookable(ev);

        var cFrag = importTemplate(root, cardTpl);
        var li = cFrag ? cFrag.querySelector('li') : null;
        if (!li) return;

        var imgLink = li.querySelector('[data-cwl-card-image-link]');
        var imgEl = li.querySelector('[data-cwl-card-img]');
        var phEl = li.querySelector('[data-cwl-card-img-placeholder]');
        var bAvail = li.querySelector('[data-cwl-badge-available]');
        var bSold = li.querySelector('[data-cwl-badge-soldout]');
        if (imgLink) imgLink.setAttribute('href', detailsHref);
        if (info.thumbnail && imgEl) {
          imgEl.hidden = false;
          imgEl.setAttribute('src', info.thumbnail);
          imgEl.setAttribute('alt', title);
          imgEl.loading = idx >= 3 ? 'lazy' : 'eager';
          if (phEl) phEl.hidden = true;
        } else {
          if (imgEl) imgEl.hidden = true;
          if (phEl) {
            phEl.hidden = false;
            phEl.textContent = title;
          }
        }
        if (bAvail && bSold) {
          if (available) {
            bAvail.hidden = false;
            bAvail.textContent = cfg.labelAvailable || 'Open';
            bSold.hidden = true;
          } else {
            bAvail.hidden = true;
            bSold.hidden = false;
            bSold.textContent = cfg.labelSoldOut || 'Uitverkocht';
          }
        }

        var titleA = li.querySelector('[data-cwl-title]');
        if (titleA) {
          titleA.textContent = title;
          titleA.setAttribute('href', detailsHref);
        }
        var dateLine = li.querySelector('[data-cwl-date-line]');
        if (dateLine) dateLine.textContent = when.dateLine;
        var timeWrap = li.querySelector('[data-cwl-time-line-wrap]');
        var timeLine = li.querySelector('[data-cwl-time-line]');
        if (when.timeLine && timeWrap && timeLine) {
          timeWrap.hidden = false;
          timeLine.textContent = when.timeLine;
        } else if (timeWrap) {
          timeWrap.hidden = true;
        }
        var priceWrap = li.querySelector('[data-cwl-price-wrap]');
        var priceEl = li.querySelector('[data-cwl-price]');
        if (ev.price && priceWrap && priceEl) {
          priceWrap.hidden = false;
          priceEl.textContent = typeof ev.price === 'string' ? ev.price : formatMoneyEur(ev.price);
        } else if (priceWrap) {
          priceWrap.hidden = true;
        }

        var act = li.querySelector('[data-cwl-actions]');
        wireBookableActions(act, cfg, {
          available: available,
          cowVal: cowVal,
          bookHref: bookHref,
          detailsHref: detailsHref,
        });

        ul.appendChild(li);
      });

      mount.appendChild(ul);
      hideLoading(root);
    } catch (e) {
      hideLoading(root);
      errEl.textContent = cfg.errorMessage || 'Kon agenda niet laden.';
      errEl.hidden = false;
    }
  }

  function readCfg(scriptEl) {
    if (!scriptEl || !scriptEl.textContent) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function uniqStrings(arr) {
    var out = [];
    var seen = Object.create(null);
    for (var i = 0; i < arr.length; i++) {
      var s = arr[i];
      if (s == null || s === '') continue;
      var t = String(s).trim();
      if (!t || seen[t]) continue;
      seen[t] = true;
      out.push(t);
    }
    return out;
  }

  function gatherSectionConfigs() {
    var servicesCfgs = [];
    var eventsCfgs = [];
    var listCfgs = [];
    function collect(sel, arr) {
      document.querySelectorAll(sel).forEach(function (root) {
        var sid = root.getAttribute('data-config-id');
        var s = sid ? document.getElementById(sid) : root.querySelector('script[type="application/json"]');
        var cfg = readCfg(s);
        if (cfg) arr.push({ root: root, cfg: cfg });
      });
    }
    collect('[data-bx-ws-cowlendar-services]', servicesCfgs);
    collect('[data-bx-ws-cowlendar-events]', eventsCfgs);
    collect('[data-bx-ws-cowlendar-events-list]', listCfgs);
    return { servicesCfgs: servicesCfgs, eventsCfgs: eventsCfgs, listCfgs: listCfgs };
  }

  /**
   * Warmt het gedeelde datamodel: services → AVS-slots + event-maanden (parallel), daarna availability voor pills.
   * Alle loaders gebruiken daarna fetchJsonCached (geen dubbele network voor dezelfde URL).
   */
  async function prefetchCowlendarSharedData(g) {
    var serviceUrls = uniqStrings(
      g.servicesCfgs
        .map(function (x) {
          return x.cfg.servicesUrl;
        })
        .concat(
          g.eventsCfgs.map(function (x) {
            return x.cfg.servicesUrl;
          }),
          g.listCfgs.map(function (x) {
            return x.cfg.servicesUrl;
          }),
        ),
    );
    await Promise.all(
      serviceUrls.map(function (u) {
        return fetchJsonCached(u).catch(function () {
          return null;
        });
      }),
    );

    var avsWarmFromServices = serviceUrls.map(function (u) {
      return fetchJsonCached(u)
        .then(function (body) {
          var list = (body && (body.services || body.data)) || [];
          if (!Array.isArray(list)) return null;
          var inner = [];
          list.forEach(function (svc) {
            if (!svc || !svc._id) return;
            var avsU = buildAvsUrlForService(u, svc._id);
            if (avsU) {
              inner.push(
                fetchJsonCached(avsU).catch(function () {
                  return null;
                }),
              );
            }
          });
          return inner.length ? Promise.all(inner) : null;
        })
        .catch(function () {
          return null;
        });
    });

    var eventTasks = [];
    function queueEvents(cfg) {
      if (!cfg || !cfg.calendarId) return;
      var months = Math.max(1, Math.min(12, Number(cfg.monthsToFetch) || 6));
      var tz = cfg.timezone || 'Europe/Amsterdam';
      var start = new Date();
      for (var i = 0; i < months; i++) {
        var d = addMonths(start, i);
        var period = periodYm(d);
        eventTasks.push(
          fetchJsonCached(buildEventsApiUrl(cfg.calendarId, period, tz)).catch(function () {
            return null;
          }),
        );
      }
    }
    g.eventsCfgs.forEach(function (x) {
      queueEvents(x.cfg);
    });
    g.listCfgs.forEach(function (x) {
      queueEvents(x.cfg);
    });

    await Promise.all(avsWarmFromServices.concat(eventTasks));

    var pillSections = g.servicesCfgs.filter(function (x) {
      return x.cfg.showAvailabilityPills;
    });
    if (pillSections.length === 0) return;

    var availJobs = [];
    pillSections.forEach(function (sc) {
      var c = sc.cfg;
      var url = c.servicesUrl;
      var monthsAhead = c.availabilityMonthsAhead != null ? Number(c.availabilityMonthsAhead) : 2;
      if (isNaN(monthsAhead) || monthsAhead < 1) monthsAhead = 2;
      var tz = c.timezone || 'Europe/Amsterdam';
      var qty = c.quantity != null ? Number(c.quantity) : 1;
      var defDur = c.defaultDuration != null ? Number(c.defaultDuration) : 270;
      availJobs.push(
        fetchJsonCached(url)
          .then(function (body) {
            var list = (body && body.services) || [];
            var months = upcomingYearMonths(monthsAhead);
            var inner = [];
            list.forEach(function (svc) {
              var v0 = svc.variants && svc.variants[0];
              if (!v0) return;
              var dur = svc.duration != null ? svc.duration : defDur;
              for (var mi = 0; mi < months.length; mi++) {
                var au = buildAvailabilityUrl(svc._id, v0.id, dur, tz, qty, months[mi].year, months[mi].month);
                inner.push(
                  fetchJsonCached(au).catch(function () {
                    return null;
                  }),
                );
              }
            });
            return Promise.all(inner);
          })
          .catch(function () {
            return null;
          }),
      );
    });
    await Promise.all(availJobs);
  }

  async function init() {
    var gathered = gatherSectionConfigs();
    await prefetchCowlendarSharedData(gathered);

    var jobs = [];
    gathered.servicesCfgs.forEach(function (x) {
      jobs.push(Promise.resolve(loadServices(x.root, x.cfg)));
    });
    gathered.eventsCfgs.forEach(function (x) {
      jobs.push(Promise.resolve(loadEvents(x.root, x.cfg)));
    });
    gathered.listCfgs.forEach(function (x) {
      jobs.push(Promise.resolve(loadEventsList(x.root, x.cfg)));
    });
    await Promise.all(jobs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init().catch(function () {});
    });
  } else {
    init().catch(function () {});
  }
})();
